import { createSlice } from "@reduxjs/toolkit";

const careTeamSlice = createSlice({
    name: "careTeams",
    initialState: {},
    reducers: {
        registerCareTeam: (state, action) => {
            const team = action.payload;
            if (!team?.id) return;

            if (!state[team.id]) {
                state[team.id] = team;
            } else {
                console.warn(
                    `⚠️ CareTeam ${team.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterCareTeams: (state, action) => {
            action.payload.forEach((team) => {
                if (!team?.id) return;

                if (!state[team.id]) {
                    state[team.id] = team;
                } else {
                    console.warn(
                        `⚠️ CareTeam ${team.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const { registerCareTeam, bulkRegisterCareTeams } = careTeamSlice.actions;
export default careTeamSlice.reducer;
